import React from 'react';
import { connect } from 'react-redux';
import Section from 'components/UIKit/Details/Content/Section';
import {
  flattenEntities,
  groupEntitiesByRole,
  groupEntitiesByType,
} from 'utils/transactions';
import TransactionDetailsNavigation from './TransactionDetailsNavigation';
import TransactionDetailsHeader from './TransactionDetailsHeader';
import DetailsPanel from '../DetailsPanel';
import { getSubmittableFileDefinitions } from 'utils/dictionaryHelpers';
import TransactionError from './TransactionError';
import DependentsError from './DependentsError';
import TransactionDocuments from './TransactionDocuments';
import TransactionActions from './TransactionActions';
import TransactionTypes from './TransactionTypes';
import TransactionInnerDetails from './TransactionInnerDetails';
import withRouting from 'utils/withRouting';

let TransactionDetails = ({
  children, style, router, projects, entityDefinitions,
  beingDeleted, dependents: existingDependents,
}) => {
  let tx = children.item;
  let entities = flattenEntities(tx.documents || []);
  let groupedByType = groupEntitiesByType(entities);
  let groupedByRole = groupEntitiesByRole(entities);

  // Checking for project id before assigning tx id to ensure the ajax is complete.
  let headerId = (tx || {}).project_id && (tx || {}).id;

  const submittableFileTypes =
    getSubmittableFileDefinitions({ defs: entityDefinitions.defs }).map(i => i.id);

  let dataFileIds = submittableFileTypes.reduce((acc, t) =>
    groupedByType[t] ? [...acc, groupedByType[t].ids] : acc, []
  ).flat();

  let hasManifest = tx.type === 'upload' && tx.state === 'SUCCEEDED' && dataFileIds.length > 0;

  let projectId = `${router.params.program}-${router.params.project}`;
  let project = projects.items.find(p => p.project_id === projectId) || {};

  let dependents = ((entities.length && tx.state === 'FAILED' && tx.type === 'delete')
     ? (entities[0].errors[0] || { dependents: [] }).dependents
     : []
   ).filter(x => existingDependents.includes(x.id));

  let processing = beingDeleted.find(x => dependents.find(y => x.ids.includes(y.id)));

  return (
    <DetailsPanel
      headerId={headerId}
      details={children}
      HeaderComponent={TransactionDetailsHeader}
      NavigationComponent={TransactionDetailsNavigation}
      style={style}
      router={router}
    >
      {tx.state === 'PENDING' &&
        <Section id="pending">
          Transaction in progress. Information will be available once the transaction is done.
        </Section>
      }
      {tx.state === 'ERROR' && <TransactionError tx={tx} /> }
      {(tx.state === 'SUCCEEDED' || tx.state === 'FAILED') &&
        <Section id="actions" header="actions">
          <TransactionActions
            tx={tx}
            project={project}
            router={router}
            hasManifest={hasManifest}
            dataFileIds={dataFileIds}
          />
        </Section>
      }
      {(tx.state === 'SUCCEEDED' || tx.state === 'FAILED') &&
        <Section id="details" header="details">
          <TransactionInnerDetails
            tx={tx}
            entities={entities}
            groupedByRole={groupedByRole}
          />
        </Section>
      }
      {tx.state === 'SUCCEEDED' && tx.type !== 'release' &&
        <Section id="types" header="Types">
          <TransactionTypes
            tx={tx}
            groupedByType={groupedByType}
          />
        </Section>
      }
      {(tx.state === 'SUCCEEDED' || tx.state === 'FAILED') && tx.type !== 'release' &&
        <Section id="documents" header="documents">
          <TransactionDocuments tx={tx} />
        </Section>
      }
      {!!(dependents || []).length &&
        <Section id="errors" header="errors">
          <DependentsError
            entities={entities}
            dependents={dependents}
            processing={processing}
          />
        </Section>
      }
    </DetailsPanel>
  );
};

export default connect(({
  projects,
  entityDefinitions,
  details: { beingDeleted, dependents },
}) => ({
  projects,
  entityDefinitions,
  beingDeleted,
  dependents,
}))(withRouting(TransactionDetails));
